<kendo-textbox
  class="k-inputs"
  [ngClass]="missingNameError ? 'red-placeholder' : 'black-placeholder'"
  [placeholder]="'STEP1.description' | translate"
  fillMode="flat"
  size="large"
  [clearButton]="false"
  [(ngModel)]="quotation.name"
></kendo-textbox>
&nbsp;
<div class="dates-container">
  <div>
    <kendo-datepicker
      class="k-inputs"
      [ngClass]="missingStartDateError ? 'red-placeholder' : 'black-placeholder'"
      [fillMode]="'flat'"
      [size]="'large'"
      [min]="today"
      [popupSettings]="{ popupClass: 'calendar' }"
      [format]="format"
      [(ngModel)]="quotation.dates.start"
      [calendarType]="'classic'"
      [showOtherMonthDays]="false"
      [placeholder]="'STEP1.startDate' | translate">
      <kendo-datepicker-messages
        [today]="'today' | translate"
      ></kendo-datepicker-messages>
    </kendo-datepicker>
  </div>
  <div>
    <kendo-datepicker
      class="k-inputs"
      [ngClass]="missingEndDateError ? 'red-placeholder' : 'black-placeholder'"
      [fillMode]="'flat'"
      [size]="'large'"
      [min]="quotation.dates.start ?? today"
      [format]="format"
      [popupSettings]="{ popupClass: 'calendar' }"
      [(ngModel)]="quotation.dates.end"
      [calendarType]="'classic'"
      [showOtherMonthDays]="false"
      [placeholder]="'STEP1.endDate' | translate">
      <kendo-datepicker-messages
        [today]="'today' | translate"
      ></kendo-datepicker-messages>
    </kendo-datepicker>
</div>
</div>
&nbsp;
<i class="question">*{{ 'STEP1.question' | translate }}</i>
